/* eslint-disable no-useless-concat */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-undef */
import React, { memo, useContext, useEffect } from 'react';
import { _O } from '../../../modules/utils';
import CanvasJSReact from '../../../modules/env/canvasjs.react';
import { AppContext } from '../../../components/AppProvider';
import { userHabit } from '../../../modules/utils/UserHabit';
import { openLayerFn } from '../../Layout';

var CanvasJSChart = CanvasJSReact.CanvasJSChart;

export default memo((props) => {
    const { title, rightTitle, rightUrl, graphTarget, graphData1, graphData2, graphData3, setTarget, setReload } = props;
    const {phonecfg} = useContext(AppContext);

    const openFullScreen = (target) => {
        if(phonecfg.phoneOS === "ANDROID") {
            window.java.appDisplayRotation(false);
            setTarget(target);
            $("#fullScreenBmi").show();
        } else { 
            window.location.href = "ep://appDisplayRotation/";
            setTarget(target);
            $("#fullScreenBmi").show();
            // openLayerFn($('.alert-layer2'));
        }

        if(target === "Bmi") {
            userHabit(phonecfg, "BM122");
        } else if(target === "골격근량") {
            userHabit(phonecfg, "BM123");
        } else if(target === "체지방량" ) {
            userHabit(phonecfg, "BM124");
        } else {
            userHabit(phonecfg, "BM125");
        }
        setReload(true);
    }

    return(
        <div className="section-box">
            <div className="section-box">
                <div className="sub-title">
                    {title}
                    {rightTitle && <BtnGoToList url={rightUrl} title={rightTitle} />}
                </div>

                <div style={{height:'300px', background:'#eee'}}>
                    {(graphTarget === "BMI" && graphData1 && graphData2 && graphData3 != undefined) && <BmiGraph trgtWght={graphData1} bmiArr={graphData2} wghtArr={graphData3} />}
                    {(graphTarget === "SMM" && graphData1) && <SmmGraph smmArr={graphData1} subTitle={"골격근량"} />}
                    {(graphTarget === "BDFT" && graphData1) && <SmmGraph smmArr={graphData1} subTitle={"체지방량"} />}
                    {(graphTarget === "VSRLFT" && graphData1) && <SmmGraph smmArr={graphData1} subTitle={"내장지방레벨"} />}

                </div>
                
                {graphTarget === "BMI" &&
                    <div className="graph-under-note">
                        <span className="bargreen">몸무게</span>
                        <span className="barpink">BMI</span>
                        <a className="btn-zoom" onClick={()=>openFullScreen("Bmi")}>그래프 확대<i></i></a>
                    </div>
                }
                
                {graphTarget === "SMM" &&
                    <div className="graph-under-note">
                        <span className="bargreen">골격근량</span>
                        <a className="btn-zoom" onClick={()=>openFullScreen("골격근량")}>그래프 확대<i></i></a>
                    </div>
                }
                
                {graphTarget === "BDFT" &&
                    <div className="graph-under-note">
                        <span className="bargreen">체지방량</span>
                        <a className="btn-zoom" onClick={()=>openFullScreen("체지방량")}>그래프 확대<i></i></a>
                    </div>
                }
                
                {graphTarget === "VSRLFT" &&
                    <div className="graph-under-note">
                        <span className="bargreen">내장지방레벨</span>
                        <a className="btn-zoom" onClick={()=>openFullScreen("내장지방레벨")}>그래프 확대<i></i></a>
                    </div>
                }
                
            </div>
        </div>
    )
});

export const GraphComponent = (props) => {
    const {title, rightTitle, rightUrl, zoomData} = props;

    return(
        <div className="section-box">
            <div className="section-box">
                <div className="sub-title">
                    {title}
                    {rightTitle && <BtnGoToList url={rightUrl} title={rightTitle} />}
                </div>

                <div style={{height:'300px', background:'#eee'}}>
                    {/* {(graphTarget == "BMI" && graphData1 && graphData2 && graphData3 != undefined) && <BmiGraph trgtWght={graphData1} bmiArr={graphData2} wghtArr={graphData3} />} */}

                </div>
                
                <ZoomGraph data={zoomData} />
                
            </div>
        </div>
    );
}

export const ZoomGraph = (props) => {
    const {data, eventHandler} = props;
    return(
        <div className={data ? data.length >= 3 ? "graph-under-note bzbtn" : "graph-under-note" : "graph-under-note"}>
            {data && data.length > 0 && <BarSubscript data={data} />}
            <a className="btn-zoom" onClick={()=>eventHandler()}>그래프 확대<i></i></a>
        </div>
    );
}

export const BarSubscript = (props) => {
    const {data} = props
    return(
        <div>
            {data.map((m,i) => (
                <span className={m.barClass} key={i}>{m.barLabel}</span>
            ))}
        </div>
    );
}

const BtnGoToList = (props) => {
    const { url, title } = props;

    return(
        <div className="btn-right">
            <a onClick={()=>_O.Open(url)}>{title}</a>
        </div>
    );
}

export const BmiGraph = (props) => {
    const {trgtWght, bmiArr, wghtArr} = props;

    let options = {
        zoomEnabled: true,
        // exportEnabled: true, 차트 이미지 추출
        height: 300,
        toolTip:{
            shared: true,
            contentFormatter: function (e) {
				var content = " ";
					content += e.entries[0].dataPoint.label.substring(0,5) + " " + e.entries[0].dataPoint.label.substring(5,11);
					content += "<br/>";
					content += "<font color='red'>" + "목표 몸무게" + ":</font>" + " " + "<strong>" + trgtWght + "</strong>";
					content += "<br/>";
					content += "<font color='#61d1bc'>" + "몸무게" + ":</font>" + " " + "<strong>" + e.entries[0].dataPoint.y + "</strong>";
					content += "<br/>";
					content += "<font color='#f990c4'>" + "BMI" + ":</font>" + " " + "<strong>" + e.entries[1].dataPoint.y + "</strong>";
				
                    return content;
			}
        },
        axisX: {
            labelAngle: 0,
            labelFontSize: 10,
        },
        axisY: {
            labelAutoFit: false,
            gridDashType: "dash",
            minimum: 0,
            maximum: 100,
            interval: 50,
            stripLines: [{
                value: trgtWght,
                color: "red",
            }]
        },
        
        axisY2: {
            labelAutoFit: false,
            gridDashType: "dash",
            minimum: 0,
            maximum: 50,
            interval: 20,
            lineColor: "#f990c4",
            stripLines: [{
                logarithmic: false,
                lineThickness: 1,
                lineColor:"#ff4d4d"

            }] 
        },

        data: [
        {   // 몸무게
            type: "line",
            axisYIndex: 0,
            markerType: "circle",
            showInLegend: false,
            lineColor: "#73c8b8",
            dataPoints: wghtArr
        },
        
        {   // BMI
            type: "line",
            axisYIndex: 1,
            axisYType: "secondary",
            markerType: "circle",
            showInLegend: false,
            lineColor: "#f990c4",
            fontColor: "#f990c4",
            dataPoints: bmiArr
        }
        ]
    }

    return(
        <div style={{marginTop:"7vw"}}>
			<CanvasJSChart options = {options} 
				/* onRef={ref => this.chart = ref} */
			/>
		</div>
    );
}

export const SmmGraph = (props) => {
    const {smmArr, subTitle} = props;
    let options = {
        zoomEnabled: true,
        // exportEnabled: true, 차트 이미지 추출
        height: 300,
        toolTip:{
            shared: true,
            contentFormatter: function (e) {
				var content = " ";
					content += e.entries[0].dataPoint.label;
					content += "<br/>";
					content += "<font color='#61d1bc'>" + subTitle + ":</font>" + " " + "<strong>" + e.entries[0].dataPoint.y + "</strong>";
				
                    return content;
			}
        },
        axisX: {
            labelAngle: 0,
            labelFontSize: 10,
        },
        axisY: {
            labelAutoFit: false,
            minimum: 0,
            maximum: 30,
            interval: 10,
        },
        data: [
        {   // 골격근량
            type: "line",
            axisYIndex: 0,
            markerType: "circle",
            showInLegend: false,
            lineColor: "#73c8b8",
            dataPoints: smmArr
        }
        ]
    }

    return(
        <div style={{marginTop:"7vw"}}>
			<CanvasJSChart options = {options} 
				/* onRef={ref => this.chart = ref} */
			/>
		</div>
    );
}